<template>
  <div class="d-flex" style="position: relative">
    <v-autocomplete
      v-if="model.autocomplete || model.autocomplete !== false"
      outlined
      :items="sortOptions"
      :item-text="textField"
      item-value="value"
      :item-disabled="checkDisabled"
      menu-props="offset-y, auto, overflowY"
      v-model="v"
      :label="$t(titleValue)"
      :error-messages="error"
      :disabled="disabled"
      :hide-details="config.hideDetails || false"
      :clearable="!readonly"
      :readonly="readonly"
      :dense="config.dense || false"
      @input_="$emit('input', $event)"
      @keydown="onKeyDown"
      :small-chips="model.chips || false"
      :multiple="model.chips || false"
      :deletable-chips="model.chips || false"
      :hide-selected="model.chips || false"
      :return-object="model.returnObject || false"
      class="list-hide-disabled"
    />
    <v-select
      v-else
      outlined
      :clearable="!readonly"
      :items="sortOptions"
      :item-text="textField"
      item-value="value"
      :item-disabled="checkDisabled"
      v-model="v"
      menu-props="offset-y, auto, overflowY"
      :label="$t(titleValue)"
      :error-messages="error"
      :disabled="disabled"
      :hide-details="config.hideDetails || false"
      :readonly="readonly"
      :dense="config.dense || false"
      @input1="onInput($event)"
      @keydown="onKeyDown"
      :small-chips="model.chips || false"
      :multiple="model.chips || false"
      :deletable-chips="model.chips || false"
      :hide-selected="model.chips || false"
      class="list-hide-disabled"
      :return-object="model.returnObject || false"
    />
    <btn-rating v-if="(model.rating && config.rating) || false" v-model="rating"> </btn-rating>
  </div>
</template>

<script>
import { libChecks, modelOptions } from "@/components/mixings";

export default {
  mixins: [libChecks, modelOptions],
  props: {
    value: [String, Number, Array, Boolean],
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },

    model: Object,
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {}, disabled: false },
  },
  data() {
    return {
      listDisabled: [],
      cc: 0,
      showAllItem: false,
      title: null,
      preText: null,
      toggleSelect: false,
      _optionsRefresh: 1,
    };
  },
  computed: {
    v: {
      get() {
        let res = this.value;
        if (this.model.chips) {
          if (res === null || res === undefined) res = [];
          if (this.model.keyInObject) {
            res = (this.value || []).map(v => v[this.model.keyInObject]);
          }
          if (!Array.isArray(res))
            try {
              res = res.split(",");
            } catch (error) {
              res = [res];
            }
        }
        return res;
      },
      set(v) {
        let res = v;
        if (this.model.keyInObject) {
          res = [
            ...v.map(e => {
              return { [this.model.keyInObject]: e };
            }),
          ];
        }
        this.onInput(res);
        //this.$emit("input", res);
      },
    },
    textField() {
      return this.model.textField || "text";
    },

    valueField() {
      return this.model?.itemField?.value || "value";
    },
    options() {
      /* if (this._optionsRefresh) {
      }
     */
      console.log("options", this.model?.name);

      return this.makeOptions();
    },
    sortOptions() {
      console.log("sort options");
      let model = this.model;
      return this.makeSortOptions(model, this.value);
      let list = JSON.parse(JSON.stringify(this.options));

      if (model?.dirVar) {
        const key = model.dirVar.key;
        if (this.values) {
          const v = model?.json ? this.values?.data?.[key] : this.values[key];
          const name = model.dirVar.dirName.find(el => {
            return el.value == v;
          });
          this.title = name?.title || null;
          this.preText = name?.preText || null;
        }
      }
      if (this.value && !list.some(list => list.value === this.value) && !Array.isArray(this.value)) {
        list = [{ text: this.value, value: this.value }, ...list];
      }
      const d = list.multiSort(["disabled", "text"]);
      return d;
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly || this.getReadonly(this.model, this.values)) return true;
      return false;
    },
    titleValue() {
      return this.title || this.model.title;
    },
    rating: {
      get() {
        let res = this.values.data?.rating?.[this.model.name] || "";
        return res;
      },
      set(v) {
        this.$emit("rating", { name: this.model.name, value: v });
      },
    },
  },
  methods: {
    makeOptions() {
      const res = this.getOptions(this.model);
      this.listDisabled = [];
      if (!res) return [];
      if (Array.isArray(res)) {
        res.forEach(e => {
          if (typeof e == "object") {
            e["disabled"] = this.checkDisabled(e);
            if (e?.isActive === undefined && typeof e === "object") {
              e.isActive = !this.checkDisabled(e);
            }
          }
        });

        return res;
        if (res) {
          const resE = res.filter(r => r?.isActive || r?.isActive == undefined);
          const resD = res.filter(r => !r.isActive);
          //  this.listDisabled = [...resD];
          return resE;
        }
      }
      return [];
    },
    makeSortOptions(model, value) {
      let list = [...this.options];

      if (this.value && !list.some(list => list.value === this.value) && !Array.isArray(this.value)) {
        list = [{ text: this.value, value: this.value }, ...list];
      }
      const d = list.multiSort(["disabled", "text"]);
      return d;
    },
    onKeyDown(e) {
      if (e.key === "*") {
        console.log("*");
        this.showAllItem = !this.showAllItem;
        this.$emit("showAllItem", this.showAllItem);
        e.preventDefault();
      }
    },

    checkDisabled(e) {
      if (this.showAllItem) return false;
      if (e?.access?.role) {
        return !(e?.access?.role || []).includes(this.$root.profile.role);
      }
      if (this.model.isActiveFunc) {
        try {
          const f = eval(`(d)=>{return ${this.model.isActiveFunc}}`);

          return !f(e);
        } catch (error) {
          console.error("Error isActive", error);
        }
      }
      if (e?.isActive === false || e.hidden) return true;
      if (e?.isActive === false || e.hidden || e?.disabled === true) return true;
      return false;
    },
    sendData(v) {
      let selected = this.options.find(d => d?.[this.valueField] == v);
      if (selected) {
        this.$emit("fieldData", selected);
      }
      this.$emit("selected", selected);
    },
    onInput(e) {
      this.$emit("input", e);
      if (this.model?.cascade) {
        for (const key in this.model.cascade) {
          const el = this.model.cascade[key];
          if (el.type == "field") {
            let value = this.options.find(f => f["value"] == e)?.[el.value];
            if (value !== undefined) {
              //this.$emit("cascade", { field: el.value, value });
              console.log("cascade ", { field: key, value });
              this.$emit("cascade", { field: key, value });
            }
          }
          if (el.type == "formula") {
            let func;
            let f = this.options.find(f => f["value"] == e)?.[el.value];
            if (typeof f == "string") func = eval(f);
            let value = func(this.values);
            if (value !== undefined) {
              this.$emit("cascade", { field: key, value });
            }
          }
        }
      }
      this.sendData(e);
    },
  },
};
</script>
<style lang="scss">
.v-list-item--disabled {
  display: none !important;
}
</style>
